import { Button, Form } from "react-bootstrap";
import { useState } from "react";
import Message from "../message";

function ApolloEmail() {
  const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

  const [file, setFile] = useState("");
  const [status, setStatus] = useState("");

  const submitFile = async () => {
    setStatus("");

    if (file.length <= 0) {
      setStatus("Upload a file!");
    } else {
      const formData = new FormData();
      formData.set("file", file);

      const requestOptions = {
        method: "POST",
        body: formData,
      };

      try {
        const response = await fetch(
          apiServer + "api/apollo_email/process",
          requestOptions
        );
        
        if (response.ok) {
          const result = await response.json();
          const statusMessage = result.detail ? result.detail : result;
          setStatus(statusMessage);
        } else {
          const errorData = await response.json();
          setStatus(errorData.detail || "An error occurred");
        }
      } catch (e) {
        console.log(e);
        setStatus("Network error occurred");
      }
    }
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <p>Upload Excel/CSV file with "Linkedin Url" column</p>
      <p>Maximum 500 LinkedIn URLs per file</p>
      <Form.Control
        type="file"
        accept=".xlsx,.csv"
        onChange={(e) => setFile(e.target.files[0])}
      />
      <Button
        style={{
          marginBottom: "15px",
          width: "100%",
          backgroundColor: "#3a4c7a",
          border: "none",
        }}
        href="./templates/apollo_email_template.xlsx"
        download
      >
        Download Template
      </Button>
      <Button
        variant="primary"
        style={{ marginTop: "20px", width: "100%" }}
        onClick={() => submitFile()}
      >
        Get Emails from Apollo
      </Button>
      {Message(status, setStatus)}
    </div>
  );
}

export default ApolloEmail;